import { render, staticRenderFns } from "./OddsList.vue?vue&type=template&id=162b9fe6&"
import script from "./OddsList.vue?vue&type=script&lang=js&"
export * from "./OddsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports